export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || `${process.env.BASE_URL}proxy/index.php`
export const SECTIONS = [
  { path: '/main', title: 'Обзор', icon: 'fa-solid fa-chart-line' },
  { path: '/tasks', title: 'Задачи', icon: 'fa-solid fa-list-check' },
  { path: '/contracts', title: 'Договоры', icon: 'fa-solid fa-file-contract' },
  { path: '/reports', title: 'Отчёты', icon: 'fa-solid fa-file-lines' },
  { path: '/seo', title: 'SEO-отчёты', icon: 'fa-solid fa-magnifying-glass-chart' },
  { path: '/invoices', title: 'Счета', icon: 'fa-solid fa-file-invoice-dollar' },
  { path: '/payments', title: 'Ваши платежи', icon: 'fa-solid fa-money-bill-transfer' },
  { path: '/works', title: 'Выполненные работы', icon: 'fa-solid fa-circle-check' },
  { path: '/sites', title: 'Домены', icon: 'fa-solid fa-globe' },
  { path: '/profile', title: 'Компания и контакты', icon: 'fa-solid fa-building' }
]
